module.exports = __webpack_public_path__ + "img/linggekj_name@3x.d50de26b.png";